import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import { Label } from '../../types/protocol.types';
import { Option } from '@telespot/protocols/data-access';

@Component({
  selector: 'ts-micro-protocol-cell',
  templateUrl: './micro-protocol-cell.component.html',
  styleUrls: ['./micro-protocol-cell.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class MicroProtocolCellComponent {
  @Input() label: Option;
  @Input() pipelineId!: string;

  @Input() multiSelection = false;
  @Input() canEdit = false;
  @Input() hasSelectedRois = false;

  /** Compact mode: show only the colour bar + number columns (hide name/actions). */
  @Input() collapsed = false;
  @HostBinding('class.micro-protocol-cell--collapsed') get isCollapsed(): boolean {
    return this.collapsed === true;
  }

  @Input() excludedFromCounter: Set<string> = new Set();
  @Input() pinnedLabels: Set<string> = new Set();
  @Input() visibleLabels: string[] = [];
  @Input() labelsInAllSelectedRois: Set<string> = new Set();
  @Input() labelsInSomeSelectedRois: Set<string> = new Set();
  @Input() selectedLabels: Label[] = [];

  @Input() displayAssetCount = 0;
  @Input() assetPctDisplay = '';
  @Input() displaySampleCount = 0;
  @Input() samplePctDisplay = '';

  @Output() readonly selectLabel = new EventEmitter<string>();
  @Output() readonly counterLabel = new EventEmitter<string>();
  @Output() readonly pinLabel = new EventEmitter<string>();
  @Output() readonly visibleLabel = new EventEmitter<string>();

  isIncompatible(): boolean {
    return this.selectedLabels.some((l) => l.pipelineId !== this.pipelineId);
  }

  isLabelSelected(optionId: string): boolean {
    return this.selectedLabels.some((l) => {
      const optionKey = 'id' in l ? (l as Label & { id: string }).id : l.uuid;
      return optionKey === optionId;
    });
  }

  isLabelInAllSelectedRois(optionId: string): boolean {
    return this.labelsInAllSelectedRois.has(optionId);
  }
}
